module.exports = __webpack_public_path__ + "assets/img/windows.54cfbd99.svg";